import * as R from 'ramda'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import querystring from 'querystring'

import * as common from '@rushplay/common'
import { lazy as loadable } from '@loadable/component'

const SearchBar = loadable(() => import('../search-bar'))
const SearchResults = loadable(() => import('./search-results'))

export function SearchPage() {
  const location = ReactRouter.useLocation()
  const history = ReactRouter.useHistory()

  const searchQuery = R.pathOr(
    '',
    ['q'],
    querystring.parse(R.drop(1, location.search))
  )

  const onSearchQueryClear = React.useCallback(
    () => history.replace(`${location.pathname}`),
    []
  )

  const onSearchQueryChange = React.useCallback(
    value => history.replace(`${location.pathname}?q=${value}`),
    []
  )

  return (
    <common.Box flexGrow="1" flexShrink="1" flexBasis="0" overflow="hidden">
      <common.Space px={[1, 2]} pb={1}>
        <common.Box backgroundColor="nav" borderRadius={1} padding={[0, 2]}>
          <SearchBar
            autoFocus
            value={searchQuery}
            onClear={onSearchQueryClear}
            onChange={onSearchQueryChange}
          />
        </common.Box>
      </common.Space>
      <SearchResults searchQuery={searchQuery} />
    </common.Box>
  )
}

// For @loadable/components
export default SearchPage
